import React from "react";
import { Container, Row, Col } from "reactstrap";
import { useTranslation } from "../../hooks/useTranslation";
import "../../styles/DeveloperCrew.css";

// Import team member images
import muhammadImg from "../../assets/all-images/team9.jpg";
import sohaibImg from "../../assets/all-images/team3.png";
import razaImg from "../../assets/all-images/team8.jpg";

const DeveloperCrew = () => {
  const t = useTranslation();

  const teamMembers = [
    {
      id: 1,
      nameKey: "developerCrew.members.muhammad.name",
      positionKey: "developerCrew.members.muhammad.position",
      image: muhammadImg,
      roleSummary: t("developerCrew.roles.muhammad"),
      expertise: [
        "developerCrew.expertise.operations",
        "developerCrew.expertise.projectManagement",
        "developerCrew.expertise.clientRelations",
        "developerCrew.expertise.digitalMarketing",
      ],
      social: {
        linkedin: "#",
        github: "#",
        email: "#",
      },
    },
    {
      id: 2,
      nameKey: "developerCrew.members.sohaib.name",
      positionKey: "developerCrew.members.sohaib.position",
      image: sohaibImg,
      roleSummary: t("developerCrew.roles.sohaib"),
      expertise: [
        "developerCrew.expertise.webDevelopment",
        "developerCrew.expertise.softwareDevelopment",
        "developerCrew.expertise.technicalLeadership",
        "developerCrew.expertise.innovation",
      ],
      social: {
        linkedin: "#",
        github: "#",
        email: "#",
      },
    },
    {
      id: 3,
      nameKey: "developerCrew.members.raza.name",
      positionKey: "developerCrew.members.raza.position",
      image: razaImg,
      roleSummary: t("developerCrew.roles.raza"),
      expertise: [
        "developerCrew.expertise.digitalMarketing",
        "developerCrew.expertise.campaignManagement",
        "developerCrew.expertise.brandBuilding",
        "developerCrew.expertise.leadGeneration",
      ],
      social: {
        linkedin: "#",
        github: "#",
        email: "#",
      },
    },
    {
      id: 4,
      nameKey: "developerCrew.members.intern.name",
      positionKey: "developerCrew.members.intern.position",
      image: null,
      roleSummary: t("developerCrew.roles.intern"),
      expertise: [
        "developerCrew.expertise.marketingSupport",
        "developerCrew.expertise.operationsSupport",
        "developerCrew.expertise.learningDevelopment",
        "developerCrew.expertise.industryExposure",
      ],
      social: {
        linkedin: "#",
        github: "#",
        email: "#",
      },
    },
  ];

  return (
    <section className="developer-crew-section" id="developer-crew">
      <Container>
        <Row className="mb-5">
          <Col lg="12" className="text-center">
            <h6 className="section__subtitle">{t("developerCrew.subtitle")}</h6>
            <h2 className="section__title">{t("developerCrew.title")}</h2>
            <p className="section__description">
              {t("developerCrew.description")}
            </p>
          </Col>
        </Row>

        <Row className="g-4 justify-content-center">
          {teamMembers.map((member) => (
            <Col lg="3" md="6" key={member.id} className="dev-crew-col">
              <div className="dev-crew__card">
                <div className="dev-crew__image-wrapper">
                  {member.image ? (
                    <img
                      src={member.image}
                      alt={t(member.nameKey)} // Use translated name for alt
                      className="dev-crew__image"
                    />
                  ) : (
                    <div className="dev-crew__placeholder">
                      <i className="ri-user-3-line"></i>
                    </div>
                  )}
                  <div className="dev-crew__overlay">
                    <div className="dev-crew__social-overlay">
                      <a href={member.social.linkedin} aria-label="LinkedIn">
                        <i className="ri-linkedin-box-fill"></i>
                      </a>
                      <a href={member.social.github} aria-label="GitHub">
                        <i className="ri-github-fill"></i>
                      </a>
                      <a href={member.social.email} aria-label="Email">
                        <i className="ri-mail-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="dev-crew__content">
                  <div className="dev-crew__header">
                    <h3 className="dev-crew__name">{t(member.nameKey)}</h3>
                    <p className="dev-crew__position">
                      {t(member.positionKey)}
                    </p>
                  </div>

                  <div className="dev-crew__role-badge">
                    <i className="ri-medal-2-line"></i>
                    <span>{t("developerCrew.roleSummaryTitle")}</span>
                  </div>

                  <p className="dev-crew__summary">{member.roleSummary}</p>

                  <div className="dev-crew__expertise">
                    <h6>{t("developerCrew.expertiseTitle")}</h6>
                    <div className="expertise-tags">
                      {member.expertise.map((exp, index) => (
                        <span key={index} className="expertise-tag">
                          {t(exp)}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <Row className="mb-5">
          <Col lg="12" className="text-center mt-5">
            <p className="section__description">
              {t("developerCrew.developerCrewContent")}
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default DeveloperCrew;
